/**
 * Supported languages: UI, emails and invoice label presets. Adding one = a locales/<code>.json,
 * an entry here, a label preset (lib/invoice/label-presets.ts), the mailer copy
 * (services/mailer/src/lib/copy.ts) and the value in the users.locale / customers.invoiceLanguage
 * migration. Native names, ordered roughly by number of speakers in the EU.
 */
export const LOCALE_NAMES = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  pl: "Polski",
  ro: "Română",
  cs: "Čeština",
  hu: "Magyar",
  sv: "Svenska",
  da: "Dansk",
  nb: "Norsk bokmål",
  fi: "Suomi",
  is: "Íslenska",
  et: "Eesti",
  lv: "Latviešu",
  lt: "Lietuvių",
  tr: "Türkçe",
} as const;

export type Locale = keyof typeof LOCALE_NAMES;
export const LOCALES = Object.keys(LOCALE_NAMES) as Locale[];

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && Object.hasOwn(LOCALE_NAMES, value);
}

/** A browser or BCP 47 tag ("de-AT", "no", "nn-NO") -> a supported locale, or undefined. */
export function toLocale(tag: string | undefined): Locale | undefined {
  const base = tag?.toLowerCase().split(/[-_]/)[0];
  if (base === "no" || base === "nn") return "nb"; // Norwegian variants share the Bokmål texts
  return isLocale(base) ? base : undefined;
}
